// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/issue-modal/issue-modal.component.css
// module id = 588
// module chunks = 0